function formatDate(dateStr) {
  if (!dateStr) return ''
  const [year, month, day] = dateStr.split('-')
  return `${day} ${['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][parseInt(month)-1]} ${year}`
}

function SetlistBrowse({ setlists, onNew, onOpen, onPresent, browseMode }) {
  const sorted = [...setlists].sort((a, b) =>
    browseMode === 'upcoming'
      ? new Date(a.date) - new Date(b.date)
      : new Date(b.date) - new Date(a.date)
  )

  return (
    <div className="setlist-browse">
      <div className="setlist-grid">
        {browseMode === 'upcoming' && (
          <button className="setlist-tile setlist-tile--new frosted ticks" onClick={onNew}>
            <span className="setlist-tile-plus">+</span>
          </button>
        )}
        {sorted.map(setlist => (
          <div
            key={setlist.id}
            className="setlist-tile frosted ticks"
            onClick={() => onOpen(setlist)}
          >
            <div className="setlist-tile-top">
              <button
                className="setlist-tile-play"
                onClick={e => { e.stopPropagation(); onPresent(setlist) }}
              >&#9654;</button>
            </div>
            <div className="setlist-tile-title fs-5">{setlist.title || 'Untitled'}</div>
            <div className="setlist-tile-date fs-6">{formatDate(setlist.date)}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default SetlistBrowse
